type PropsT = {
  scrollLeft: number;
  mouseXPosition: number;
  frameWidth: number;
  maxFrames: number;
};
export function getFrameIndex({
  scrollLeft,
  mouseXPosition,
  frameWidth,
  maxFrames
}: PropsT) {
  const columnIndex = Math.floor((scrollLeft + mouseXPosition) / frameWidth);
  if (columnIndex < 0) {
    return 0;
  }
  if (columnIndex >= maxFrames) {
    return maxFrames - 1;
  }
  return columnIndex;
}